'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

const AboutHeadline = () => {
  const translate = useTranslate('about_mission.motivation')
  const asset = useAsset('/assets/about')

  return (
    <>
      <Spacer size={Spacer.Size.X4Large} />
      <div className="u-tablets-up-only">
        <Spacer size={Spacer.Size.X4Large} />
      </div>
      <div className="about__section">
        <Text as="h1" type={Text.Type.HeadingXXL} alignment={Text.Alignment.Left}>
          <span className="c-text--responsive-large-heading">{translate('title')}</span>
        </Text>
        <Spacer size={Spacer.Size.X2Large} />
        <div className="u-tablets-up-only">
          <Spacer size={Spacer.Size.X2Large} />
        </div>
        <Text as="p">
          <span className="c-text--responsive-large-body">{translate('text')}</span>
        </Text>
      </div>
      <Spacer size={Spacer.Size.X4Large} />
      <div className="u-tablets-up-only">
        <Spacer size={Spacer.Size.X4Large} />
      </div>
      <div className="u-tablets-up-only">
        <div className="about__hero-image">
          <Image src={asset('about-us-desktop.jpg')} scaling={Image.Scaling.Cover} />
        </div>
      </div>
      <div className="u-phones-only">
        <div className="about__hero-image">
          <Image src={asset('about-us-mobile.png')} scaling={Image.Scaling.Cover} />
        </div>
      </div>
    </>
  )
}

export default AboutHeadline
